import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import PropertyValue from './PropertyValue';
import ColorValue from './ColorValue';

@observer
class Property extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: this.getProperty().value
    }

    this.init();

    // console.log("NEW");
  }

  test() {
    if(this.getType() === "string")
      this.updatePropWithNewValue("hacked");
  }

  componentDidMount() {
    if(this.props.onRef)
      this.props.onRef(this);
  }

  updatePropWithNewValue(val) {
    // this.getProperty().value = val;
    if(this.props.element)
      this.props.element.setValue(this.getKey(), val);
    this.changePropValue(val);
    this.setState({
      value: val
    })

    // console.log(this.changePropValue);
  }

  getProperty() {
    return this.props.property;
  }

  getType() {
    return this.getProperty().type;
  }

  getValue() {
    return this.getProperty().value;
  }

  getKey() {
    return this.getProperty().key;
  }

  // componentDidUpdate() {
  //   if(this.key.toLowerCase() === "blocksize")
  //     console.log(this.value, this.props.property.value);
  // }

  init() { }

  getPropertyValue() {
    // if(this.getKey().toLowerCase() === "blocksize")
      // console.log(this.getValue());
    switch(this.getType().toLowerCase().trim()) {
      case 'color':
        return <ColorValue change={(changeProp) => this.changePropValue = changeProp} onChange={(val) => {
          this.updatePropWithNewValue(val);
          this.props.onChange(val);
        }} getValue={this.getValue.bind(this)} />

      default:
        return <PropertyValue change={(changeProp) => this.changePropValue = changeProp} onChange={(val) => {
          this.updatePropWithNewValue(val);
          this.props.onChange(val);
        }} getValue={this.getValue.bind(this)} />
    }
  }

  getNiceKey() {
    if(this.getKey().charAt(0) === this.getKey().charAt(0).toUpperCase())
      return this.getKey();
    return this.getKey().replace(/([A-Z])/g, "-$1").toLowerCase();
  }

  render() {
    const isObj = typeof this.getValue() === "object";
    const html = isObj ? (
      <div className="properties">
        <div className="cat">{this.getKey()}</div>
        <div className="values">
          {Object.keys(this.getValue()).map((key, index) => {
            return (
              <div className="property">
                <div className="key">{key}</div>
                <div className="value">
                  <PropertyValue value={this.getValue()[key]} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ) : (
      <div className="property">
        <div className="key">{this.getNiceKey()}</div>
        <div className="value">{this.getPropertyValue()}</div>
      </div>
    );
    return html;
  }
}

export default Property;



// WEBPACK FOOTER //
// ./src/components/ui/Property.js